import { createStore } from "vuex";
import axios from "axios";
import helper from "@/helper";
import router from "@/router";

export default createStore({
  state: {
    navigationMode: false,
    userInfo: null,
    currentMenuID: null,
  },
  getters: {
    getNavMode: (state) => {
      return state.navigationMode;
    },
    getCurrentMenuID: (state) => {
      return state.currentMenuID;
    },
    getUserInfo: (state) => {
      return state.userInfo;
    },
  },
  mutations: {
    setUserInfo(state, receivedUserInfo){
      state.userInfo = receivedUserInfo;
      
    }
  },
  actions: {
    toggleNavigation({state}){
      state.navigationMode = !state.navigationMode;
    },
    setCurrentMenuId({state}, menuID){
      state.currentMenuID = menuID;
    },
    setNavigationMode({state}, mode){
      state.navigationMode = mode;
    },
    async getAuthorization({commit}, {email, password}){
      await axios.post('auth', {email, password, isMobile: 0}).then(async (response) => {
        commit("setUserInfo", response.data[0]);
        window.localStorage.setItem("BearerToken", response.data[0].token);
        axios.defaults.headers.common.Authorization = `Bearer ${response.data[0].token}`;
        router.push({path: '/'});
      }).catch((error) => {
        
        if(error?.response?.status == 422){
          helper.initializeSwalWithoutTimer("არასწორი იმეილი ან პაროლი", "error", "", true);
        }
        return;
      })
    },
    async getInfoOnRefresh({commit}){
      await axios.post('getInfoOnRefresh', {isMobile: 0}).then(async (response) => {
        commit("setUserInfo", response.data);
      })
    },
    logout({state}){
      axios.post('/logout', {isMobile: 0}).then(() => {
        window.localStorage.removeItem("BearerToken");
        state.userInfo = null;
        router.replace("/login");
      })
    },
    createOrganization({state}, formData){
      // console.log(formData);
      // for(let entries of formData.entries()){
      //   console.log(entries);
      // }
      return axios.postForm("addOrganizations", formData);
    },
    addOffices({state}, formData){
      return axios.post("addOffices", formData);
    },
    getOffices(){
      return axios.get("getOffices");
    },
    addPositions({state}, formData){
      // for(let entries of formData.entries()){
      //   console.log(entries);
      // }
      return axios.postForm("addPositions", formData);
    },
    getPositions({state}, {officeID}){
      return axios.get(`getPositions/${officeID}`);
    },
    addMunicipalities({state}, municipalityData){
      return axios.post("addMunicipalities", municipalityData);
    },
    getMunicipalities(){
      return axios.get("getMunicipalities");
    },
    addCities({state}, cityData){
      return axios.post("addCities", cityData);
    },
    getCities({state}, municipalityID){
      return axios.get(`/getCities/${municipalityID}`);
    },
    addRegions({state}, regionData){
      return axios.post("addRegions", regionData);
    },
    getRegionsAll(){
      return axios.get("getRegionsAll");
    },
    getRegions({state}, cityID){
      return axios.get(`/getRegions/${cityID}`);
    },
    addDistrict({state}, districtData){
      return axios.post("addDistrict", districtData);
    },
    
    getAgeRanges(){
      return axios.get("ageRanges");
    },
    getGenders(){
      return axios.get("getGenders");
    },
    getDistricts({state}, regionID){
      return axios.get(`getDistricts/${regionID}`);
    },

    getMenus(){
      return axios.get("getMenus");
    },
    getAllMenusForOrganizationUsers(){
      return axios.get("getAllMenusForOrganizationUsers");
    },
    getUsers(){
      return axios.get("getUsers");
    },
    addUsers({state}, formData){
      return axios.postForm("addUsers", formData);
    },
    addMenuToUser({state}, menuUserData){
      return axios.post("addMenuToUser", menuUserData);
    },

    // supporters and members >>
    getRespodent({state}, obj){
      let text = obj.text?`text:${obj.text},`:"";
      let seen = obj.seen || obj.seen === 0?`seen:${obj.seen},`:"";
      let cityID = obj.cityID?`cityID:${obj.cityID},`:"";
      let regionID = obj.regionID?`regionID:${obj.regionID},`:"";
      let districtID = obj.districtID?`districtID:${obj.districtID},`:"";
      let genderID = obj.genderID || obj.genderID === 0?`genderID:${obj.genderID},`:"";
      let ageRange = obj.ageRange?`ageRange:${obj.ageRange},`:"";
      let dateRange = obj.dateRange?`dateRange:${obj.dateRange},`:"";
      let respodent_statusID = obj.respodent_statusID?`respodent_statusID:${obj.respodent_statusID},`:"";
      let filters = `${seen}${text}${cityID}${regionID}${districtID}${genderID}${ageRange}${dateRange}${respodent_statusID}`;

      return axios.get("getRespodent", {
        params: {
          filters,
          respodent_typeID: obj.respodent_typeID,
          offset: obj.offset,
          limit: obj.limit,
        },
        signal: obj?.signal??null,
      });
    },
    deleteRespodent({state}, {respodentID}){
      return axios.post("deleteRespodent", {
        respodentID,
      });
    },
    getGoingTypes(){
      return axios.get("getGoingTypes");
    },
    getSupportersInfo({state}, {respodent_typeID, cityID, regionID, districtID}){
      let paramsObj = {};
      // if(districtID){
      //   paramsObj.districtID = String(districtID);
      //   paramsObj.dataName = "district";
      // }else if(regionID){
      //   paramsObj.regionID = String(regionID);
      //   paramsObj.dataName = "region";
      // }else if(cityID){
      //   paramsObj.cityID = String(cityID);
      //   paramsObj.dataName = "city";
      // }else{
      //   paramsObj.dataName = "country";
      // }
      paramsObj.dataName = "country";
      return axios.get("getSupportersInfo", {
        params: {
          respodent_typeID,
          ...paramsObj,
        }
      });      
    },
    getCitiesWithSupporterCount({state}, obj){
      return axios.get("getCitiesWithSupporterCount", {
        params: {
          ...obj,
        }
      });
    },
    supporterDetailsForMap({state}, obj){
      return axios.get("supporterDetailsForMap", {
        params: {
          ...obj,
        }
      });
    },
    addRespodent({state}, addOrCorrectSupportersObj){
      let obj = {...addOrCorrectSupportersObj};
      delete obj?.respodentID;
      
      return axios.post("addRespodent", obj);
    },
    editRespodent({state}, addOrCorrectSupportersObj){
      return axios.post("editRespodent", {...addOrCorrectSupportersObj});
    },
    addRespodentComments({state}, obj){
      return axios.post("addRespodentComments", obj);
    },
    getRespodentComments({state}, respodentID){
      return axios.get(`getRespodentComments/${respodentID}`);
    },
    getMoods(){
      return axios.get("getMoods");
    },
    getRespodentStatuses(){
      return axios.get("respodentStatuses");
    },
    // problems page >>
    getUserProblems({state}, {offset, limit, search, problemTypeIDs, cityID, regionID, cutomDateRange, signal, seen, status}){
      let paramsObj = {
        offset,
        limit,
      };
      let filtersArray = [];
      if(search?.length > 0){
        filtersArray.push(`userID:${search.join(";")}`);
      }
      
      if(problemTypeIDs?.length > 0){
        filtersArray.push(`problem_typeID:${problemTypeIDs.join(";")}`);
      }
      if(status?.length > 0){
        filtersArray.push(`problem_statusID:${status.join(";")}`);
      }
      if(cutomDateRange){
        filtersArray.push(`dateRange:${cutomDateRange}`);
      }

      if(regionID){
        filtersArray.push(`regionID:${regionID}`);
        // filtersArray.push(`cityID:0`);

      }else if(cityID){
        filtersArray.push(`cityID:${cityID}`);
        // filtersArray.push(`regionID:0`);
      }
      
      seen == 1 || seen == 0?filtersArray.push(`seen:${seen}`):"";

      paramsObj.filters = filtersArray.join(",");
      
      return axios.get("getUserProblems", {
        signal: signal?signal:null,
        params: {
          ...paramsObj,
        }
      });
    },
    getUserProblemLocations({state}, {offset, limit, search, problemTypeIDs, cityID, regionID, cutomDateRange, signal}){
      let paramsObj = {
        offset,
        limit,
      };
      let filtersArray = [];
      if(search?.length > 0){
        filtersArray.push(`userID:${search.join(";")}`);
      }
      
      if(problemTypeIDs?.length > 0){
        filtersArray.push(`problem_typeID:${problemTypeIDs.join(";")}`);
      }
      if(cutomDateRange){
        filtersArray.push(`dateRange:${cutomDateRange}`);
      }

      if(regionID){
        filtersArray.push(`regionID:${regionID}`);
        // filtersArray.push(`cityID:0`);

      }else if(cityID){
        filtersArray.push(`cityID:${cityID}`);
        // filtersArray.push(`regionID:0`);
      }
      paramsObj.filters = filtersArray.join(",");
      
      return axios.get("getUserProblemLocations", {
        signal: signal?signal:null,
        params: {
          ...paramsObj,
        }
      });
    },
    getProblemStatistic({state}, {regionID, cityID}){
      // let paramsObj = {};

      // if(regionID){
      //   paramsObj.regionID = regionID;
      //   paramsObj.cityID = 0;
      // }else if(cityID){
      //   paramsObj.cityID = cityID;
      //   paramsObj.regionID = 0;
      // }
      return axios.get("problemStatistic", {
        // params: {
        //   ...paramsObj,
        // },
      });
    },
    getProblemStatisticDetailed({state}, {regionID, cityID}){
      let paramsObj = {};

      if(regionID){
        paramsObj.regionID = regionID;
        paramsObj.cityID = 0;
      }else if(cityID){
        paramsObj.cityID = cityID;
        paramsObj.regionID = 0;
      }
      return axios.get("problemStatisticDetailed", {
        params: {
          ...paramsObj,
        },
      });
    },
    detailedProblemsByCityOrRegion({state}, paramObj){
      return axios.get("detailedProblemsByCityOrRegion", {
        params: paramObj,
      });
    },
    cityAndRegionByProblemType({state}, paramObj){
      return axios.get("cityAndRegionByProblemType", {
        params: paramObj,
      });
    },
    getProblemStatisticDetailedWithoutFilters({state}, {regionID, cityID}){
      return axios.get("problemStatisticDetailed");
    },
    getProblemTypes(){
      return axios.get("getProblemTypes");
    },
    setProblemStatus({state}, obj){
      return axios.post("setProblemStatus", {...obj});
    },
    getDetailedProblemByProblemID({state}, {user_problemID}){
      return axios.get("getDetailedProblemByProblemID", {
        params: {
          user_problemID,
        }
      });
    },
    deleteUserProblem({state}, {user_problemID}){
      return axios.post("deleteUserProblem", {user_problemID});
    },
    seenUserProblem({state}, {user_problemID}){
      return axios.post("seenUserProblem", {user_problemID});
    },
    editUserProblems({state}, obj){
      return axios.post("editUserProblems", obj);
    },
    addUserProblemsMedia({state}, obj){
      let formData = new FormData();
      Object.keys(obj).forEach((key) => {
        formData.append(key, obj[key]);
      });
      
      return axios.postForm("addUserProblemsMedia", formData);
    },
    deleteProblemMediaFiles({state}, obj){
      return axios.post("deleteProblemMediaFiles", obj);
    },
    getProblemStatuses(){
      return axios.get("getProblemStatuses");
    },
    getUserProblemIdentifiers(){
      return axios.get("userProblemIdentifiers");
    },
    getProblemAudio({state}, {file_name, user_problemID, signal}){
      return axios.post("getProblemAudio", {file_name, user_problemID}, {
        responseType: "blob",
        signal,
      });
    },
    getProblemVideo({state}, {file_name, user_problemID, signal}){
      return axios.post("getProblemVideo", {file_name, user_problemID}, {
        responseType: "blob",
        signal,
      });
    },
    setAdditionalComment({state}, {user_problemID, vizireba}){
      return axios.post("setVizireba", {
        user_problemID,
        vizireba,
      });
    },
    //mobilisation page >>
    getMobilizationUsers({state}, obj){ // 1 = tanamshromeli, 2 = member/supporter
      let text = obj.text?`text:${obj.text},`:"";
      let cityID = obj.cityID?`cityID:${obj.cityID},`:"";
      let districtID = obj.districtID?`districtID:${obj.districtID},`:"";
      let going_typeID = obj.going_typeID?`going_typeID:${obj.going_typeID},`:"";
      let hasComment = obj.hasComment?`hasComment:${obj.hasComment},`:"";

      let filters = `${text}${cityID}${districtID}${going_typeID}${hasComment}`;
      return axios.get("getMobilizationUsers", {
        params: {
          isMobile: 0,
          user_type: obj.user_type?obj.user_type:2,
          offset: obj.offset?obj.offset:0,
          limit: obj.limit,
          filters: filters,
        }
      });
    },
    getDistrictsByCity({state},cityID){
      return axios.get(`getDistrictsByCity/${cityID}`);
    },
    addMobilizationComments({state}, commentsObj){
      return axios.post("addMobilizationComments", commentsObj);
    },
    mobilizationInfoByUser({state}, {userID, user_type}){
      return axios.post("mobilizationInfoByUser", {userID: userID, user_type, isMobile: 0});
    },
    getCitiesAll(){
      return axios.get("getCitiesAll");
    },
    // election page >>
    getElectionUserProblems({state}, obj){
      // let municipalityID = obj.municipalityID?`municipalityID:${obj.municipalityID},`:"";
      let cityID = obj.cityID?`cityID:${obj.cityID},`:"";
      let regionID = obj.regionID?`regionID:${obj.regionID},`:"";
      let districtID = obj.districtID?`districtID:${obj.districtID},`:"";
      let problemTypeID = obj.problemTypeID?`problemTypeID:${obj.problemTypeID},`:"";
      let hasComment = obj.hasComment?`hasComment:${obj.hasComment},`:"";
      let hasMedia = obj.hasMedia?`hasMedia:${obj.hasMedia},`:"";
      let seen = obj.seen?`seen:${obj.seen},`:"";
      let filters = `${cityID}${regionID}${districtID}${problemTypeID}${hasComment}${hasMedia}${seen}`;
      
      return axios.get("getElectionUserProblems", {
        params: {
          offset: obj.offset?obj.offset:0,
          limit: obj.limit,
          filters: filters,
        },
        signal: obj.signal?obj.signal:null,
      });
    },
    getElectionProblemTypes(){
      return axios.get("getElectionProblemTypes");
    },
    getElectionUsers({state}, obj){
      return axios.post("getElectionUsers", obj);
    },
    getElectionProblemVideo({state}, obj){
      return axios.post("getElectionProblemVideo", obj, {
        responseType: 'blob',
      });
    },
    getRegionsByPath({state}, pathID){
      return axios.get(`getRegionsByPath?pathID=${pathID}`);
    },
    electionProblemIsSeen({state}, election_problemID){
      return axios.post("electionProblemIsSeen", {election_problemID});
    },
    getDistrictDetails({state}, id){
      return axios.get(`getDistrictDetails?districtID=${id}`);
    },
    getCountryCount(){
       return axios.get("getCountryCount");
    },
    electionStatistic({state}, {cityID, regionID, districtID}){
      let paramsObj = {};
      
      if(districtID){
        paramsObj.districtID = String(districtID);
      }else if(regionID){
        paramsObj.regionID = String(regionID);
      }else if(cityID){
        paramsObj.cityID = String(cityID);
      }
      
      return axios.get("electionStatistic", {
        params: {
          ...paramsObj,
        },
      });
    },
    getDetailedStatisticAll({state}, obj){
      
      let dataName = obj.dataName == 1?"district":"region";
      let orderBy = obj.orderBy?obj.orderBy:"elect_count:desc";
      
      return axios.get("getDetailedStatisticAll", {
        params: {
          offset: obj.offset,
          limit: obj.limit,
          dataName: dataName,
          orderBy, 
        },
        signal: obj.signal?obj.signal:null,
      });
    },
    electionUsersByDistrict({state}, {districtID, signal}){
      return axios.get(`electionUsersByDistrict/${districtID}`, {
        signal: signal?signal:null,
      });
    },
    getDetailedStatisticProblem({state}, obj){
      let dataName = obj.dataName == 1?"district":obj.dataName == 2?"country":"region";
      let orderBy = obj.orderBy?obj.orderBy:"elect_count:desc";
      
      return axios.get("getDetailedStatisticProblem", {
        params: {
          offset: obj.offset,
          limit: obj.limit,
          dataName: dataName,
          orderBy, 
        },
        signal: obj.signal?obj.signal:null,
      });
    },
    getElectionProblemTypesByRegion({state}, regionID){
      return axios.get(`getElectionProblemTypesByRegion?regionID=${regionID}`);
    },
    getDistrictsByRegionAndProblemType({state}, {election_problem_typeID, regionID}){
      return axios.get(`getDistrictsByRegionAndProblemType?regionID=${regionID}&election_problem_typeID=${election_problem_typeID}`);
    },
    getElectionProblemTypesByDistrict({state}, {districtID}){
      return axios.get(`getElectionProblemTypesByDistrict?districtID=${districtID}`);
    },
    getRegionsByCountryProblemType({state}, {election_problem_typeID}){
      return axios.get(`getRegionsByCountryProblemType?election_problem_typeID=${election_problem_typeID}`);
    },
    getElectionProblemDistrictsByRegion({state}, {regionID,election_problem_typeID}){
      return axios.get(`getElectionProblemDistrictsByRegion?election_problem_typeID=${election_problem_typeID}&regionID=${regionID}`);
    },
    getRegionActivities({state}, {regionID}){
      return axios.get(`getRegionActivities/${regionID}`);
    },
    electionUsersByDistrictForExcel({state}, {regionID, signal}){
      return axios.get(`electionUsersByDistrictForExcel/${regionID}`, {
        signal: signal?signal:null,
      });
    },
    // for finalResults >>
    getElectionTotalResults({state}, {districtID, regionID, cityID, result_typeID, election_typeID}){
      let paramsObj = {};
      if(districtID){
        paramsObj.districtID = String(districtID);
        paramsObj.dataName = "district";
      }else if(regionID){
        paramsObj.regionID = String(regionID);
        paramsObj.dataName = "region";
      }else if(cityID){
        paramsObj.cityID = String(cityID);
        paramsObj.dataName = "city";
      }else{
        paramsObj.dataName = "country";
      }
      paramsObj.result_typeID = result_typeID?result_typeID:1;
      paramsObj.election_typeID = election_typeID?election_typeID:1;


      return axios.get("getElectionTotalResults", {
        params: {
          ...paramsObj,
        }
      });
    },
    activityDetails({state}, paramsObj){
      let dataName = paramsObj.dataName == 1?"district":"region";
      let orderBy = paramsObj.orderBy?paramsObj.orderBy:"attendance:desc";
      return axios.get("activityDetails", {
        params: {
          dataName,
          orderBy,
          limit: paramsObj.limit,
          offset: paramsObj.offset,
          result_typeID: paramsObj.result_typeID?paramsObj.result_typeID:1,
          election_typeID: paramsObj.election_typeID?paramsObj.election_typeID:1,
        },
        signal: paramsObj.signal?paramsObj.signal:null,
      })
    },
    getElectionResults({state}, {districtID, regionID, cityID, limit, offset, result_typeID, signal, election_typeID}){
      let paramsObj = {};
      
      if(districtID){
        paramsObj.filters = `districtID:${String(districtID)}`;
      }else if(regionID){
        paramsObj.filters = `regionID:${String(regionID)}`;
      }else if(cityID){
        paramsObj.filters = `cityID:${String(cityID)}`;
      }
      return axios.get("getElectionResults", {
        params: {
          ...paramsObj,
          limit: limit,
          offset: offset,
          result_typeID: result_typeID?result_typeID:1,
          election_typeID: election_typeID?election_typeID:1,
        },
        signal: signal?signal:null,
      })
    },
    getParties(){
      return axios.get("getParties");
    },
    addElectionResultsFromAdmin({state}, changedSingleFinalResultsObj){
      let partyID = [];
      let amount = [];
      let attendance = [];
      let rejected = [];
      let districtID = [];
      let changedSingleFinalResultsLocaleObj = changedSingleFinalResultsObj.changedSingleFinalResultsObj;

      
      
      Object.keys(changedSingleFinalResultsLocaleObj).forEach((resKey) => {
        partyID.push(changedSingleFinalResultsLocaleObj[resKey].partyID);
        amount.push(changedSingleFinalResultsLocaleObj[resKey].amount);
        attendance.push(changedSingleFinalResultsLocaleObj[resKey].attendance);
        rejected.push(changedSingleFinalResultsLocaleObj[resKey].rejected);
        districtID.push(changedSingleFinalResultsLocaleObj[resKey].districtID);
      })
      
      return axios.post("addElectionResultsFromAdmin", {
        partyID,
        amount,
        attendance,
        rejected,
        districtID,
        result_typeID: changedSingleFinalResultsObj.result_typeID?changedSingleFinalResultsObj.result_typeID:1,
        election_typeID: changedSingleFinalResultsObj.election_typeID?changedSingleFinalResultsObj.election_typeID:1,
      })
    },
    addElectionResultMedia({state}, formData){
      // for(let pair of formData.entries()){
      //   console.log(pair);
      // }
      return axios.postForm("addElectionResultMedia", formData);

    },
    getResultTypes(){
      return axios.get('getResultTypes');
    },
    getElectionTypes(){
      return axios.get("getElectionTypes");
    },
    // for exit poll page >>
    getExitPollTotalResults({state}, {districtID, regionID, cityID, election_typeID}){
      let paramsObj = {};
      if(districtID){
        paramsObj.districtID = String(districtID);
        paramsObj.dataName = "district";
      }else if(regionID){
        paramsObj.regionID = String(regionID);
        paramsObj.dataName = "region";
      }else if(cityID){
        paramsObj.cityID = String(cityID);
        paramsObj.dataName = "city";
      }else{
        paramsObj.dataName = "country";
      }

      return axios.get("getExitPollTotalResults", {
        params: {
          ...paramsObj,
          election_typeID: election_typeID,
        }
      });
    },
    getExitPollUsersDetails({state}, {partyID, party_typeID, districtID, regionID, cityID, offset, limit, election_typeID}){
      let paramsObj = {};
      if(districtID){
        paramsObj.districtID = String(districtID);
        paramsObj.dataName = "district";
      }else if(regionID){
        paramsObj.regionID = String(regionID);
        paramsObj.dataName = "region";
      }else if(cityID){
        paramsObj.cityID = String(cityID);
        paramsObj.dataName = "city";
      }else{
        paramsObj.dataName = "country";
      }
      return axios.get("getExitPollUsersDetails", {
        params: {
          partyID,
          party_typeID,
          ...paramsObj,
          offset,
          limit,
          election_typeID,
        },
      });
    },
    // for news and activities >>
    addNews({state}, formData){
      return axios.postForm("addNews",formData);
    },
    editNews({state}, formData){
      return axios.postForm("editNews", formData);
    },
    deleteNews({state}, newsID){
      return axios.post("deleteNews", {newsID});
    },
    getNews({state}, confObj){
      return axios.get("getNews", {
        params: {
          ...confObj,
        }
      });
    },
    getLinkTypes(){
      return axios.get("getLinkTypes");
    },
    // for door2door >>
    seenUserDoorProblem({state}, {user_doorID}){
      return axios.post("seenUserDoorProblem", {user_doorID});
    },
    getDoor2DoorData({state}, obj){
      let address = obj.search?`address:${obj.search},`:"";
      let seen = obj.seen || obj.seen === 0?`seen:${obj.seen},`:"";
      let cityID = obj.cityID?`cityID:${obj.cityID},`:"";
      let regionID = obj.regionID?`regionID:${obj.regionID},`:"";
      let dateRange = obj.dateRange?`dateRange:${obj.dateRange},`:"";
      let moodID = obj.moodID?`moodID:${obj.moodID},`:"";
      let going_typeID = obj.isGoing?`going_typeID:${obj.isGoing},`:"";
      let party_typeID = obj.oppositionOrPosition?`party_typeID:${obj.oppositionOrPosition},`:"";
      let officeID = obj.officeID?`officeID:${obj.officeID},`:"";
      let door_problem_type = obj.door_problem_type?`door_problem_type:${obj.door_problem_type},`:"";

      let filters = `${seen}${address}${cityID}${regionID}${dateRange}${moodID}${going_typeID}${party_typeID}${officeID}${door_problem_type}`;
      
      return axios.get("getDoor2DoorData", {
        params: {
          filters,
          offset: obj.offset,
          limit: obj.limit,
        },
        signal: obj?.signal??null,
      });
    },
    getDoorProblemType(){
      return axios.get("getDoorProblemType");
    },
    user_doors_flyer_count(){
      return axios.get("user_doors_flyer_count");
    },
    user_doors_going_type_count(){
      return axios.get("user_doors_going_type_count");
    },
    user_doors_mood_count(){
      return axios.get("user_doors_mood_count");
    },
    user_doors_party_type_count(){
      return axios.get("user_doors_party_type_count");
    },
    user_doors_problem_max_count(){
      return axios.get("user_doors_problem_max_count");
    },
    dataForGraph({state}, weekOrDay){ // 1 for week, 2 - day
      return axios.get(`dataForGraph?reportType=${weekOrDay}`);
    },
    countsByCityAndFlyerTypes({state}, obj){
      let cityName = obj.search?`cityName:${obj.search},`:"";
      let dateRange = obj?.date?.length > 1?`dateRange:${obj.date[0]}_${obj.date[1]},`:"";
      let sortKey = 'ბეჭდური';
      let direction = 'desc';
      if(obj.sort){
        let newVals = obj.sort.split(':');
        sortKey = newVals[0];
        direction = newVals[1];
      }
      let filters = `${cityName}${dateRange}`;
      

      
      return axios.get("countsByCityAndFlyerTypes", {
        params: {
          filters,
          sortKey,
          direction,
        }
      });
    },
    latLngInfo({state}, obj){
      return axios.get(`latLngInfo?rejimi=${obj.rejimi}&city=${obj.city}`);
    },
    user_door_party_type_detail_counts({state}, obj){
      let cityName = obj.search?`cityName:${obj.search},`:"";
      let dateRange = obj?.date?.length > 1?`dateRange:${obj.date[0]}_${obj.date[1]},`:"";
      let sortKey = 'ოპოზიცია';
      let direction = 'desc';
      if(obj.sort){
        let newVals = obj.sort.split(':');
        sortKey = newVals[0];
        direction = newVals[1];
        
      }
      let filters = `${cityName}${dateRange}`;
      return axios.get("user_door_party_type_detail_counts", {
        params: {
          filters,
          sortKey,
          direction,
        }
      });
    },
    user_doors_mood_detail_counts({state}, obj){
      let cityName = obj.search?`cityName:${obj.search},`:"";
      let dateRange = obj?.date?.length > 1?`dateRange:${obj.date[0]}_${obj.date[1]},`:"";
      let sortKey = 'დადებითი';
      let direction = 'desc';
      if(obj.sort){
        let newVals = obj.sort.split(':');
        sortKey = newVals[0];
        direction = newVals[1];
      }
      let filters = `${cityName}${dateRange}`;
      
      return axios.get("user_doors_mood_detail_counts", {
        params: {
          filters,
          sortKey,
          direction,
        }
      });
    },
    user_door_going_type_detail_counts({state}, obj){
      let cityName = obj.search?`cityName:${obj.search},`:"";
      let dateRange = obj?.date?.length > 1?`dateRange:${obj.date[0]}_${obj.date[1]},`:"";
      let sortKey = 'მოვდივარ';
      let direction = 'desc';
      if(obj.sort){
        let newVals = obj.sort.split(':');
        sortKey = newVals[0];
        direction = newVals[1];
      }
      let filters = `${cityName}${dateRange}`;
      return axios.get("user_door_going_type_detail_counts", {
        params: {
          filters,
          sortKey,
          direction,
        }
      });
    },
    user_door_problem_type_detail_counts({state}, obj){
      let cityName = obj.search?`cityName:${obj.search},`:"";
      let dateRange = obj?.date?.length > 1?`dateRange:${obj.date[0]}_${obj.date[1]},`:"";
      let sortKey = 'სხვა';
      let direction = 'desc';
      if(obj.sort){
        let newVals = obj.sort.split(':');
        sortKey = newVals[0];
        direction = newVals[1];
      }
      let filters = `${cityName}${dateRange}`;
      return axios.get("user_door_problem_type_detail_counts", {
        params: {
          filters,
          sortKey,
          direction,
        }
      });
    },
    flyerTypes(){
      return axios.get("flyerTypes");
    },
  },
  modules: {},
});
